import { useCallback } from 'react';
import { usePublishDraftJobPost } from '~/domain/PermanentJobs';

interface IUsePublishJobPostPayload {
  jobPostingId?: string;
  planId?: string;
  onSuccess?: () => void;
}

export const usePublishJobPost = ({
  jobPostingId,
  planId,
  onSuccess,
}: IUsePublishJobPostPayload) => {
  const { error, isError, isPending, mutate } = usePublishDraftJobPost();

  const doPublish = useCallback(() => {
    if (!jobPostingId || !planId) {
      return;
    }

    mutate(
      { jobPostingId, planId },
      {
        onSuccess,
      },
    );
  }, [jobPostingId, planId, mutate, onSuccess]);

  return {
    isLoading: isPending,
    doPublish,
    isError,
    error,
  };
};
